import { render, staticRenderFns } from "./add-assistant.vue?vue&type=template&id=0218290d&scoped=true&"
import script from "./add-assistant.vue?vue&type=script&lang=js&"
export * from "./add-assistant.vue?vue&type=script&lang=js&"
import style0 from "./add-assistant.vue?vue&type=style&index=0&id=0218290d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0218290d",
  null
  
)

export default component.exports